import React from 'react';
import { Quote, Star } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Carlos M.',
      location: 'São Paulo, SP',
      text: 'Tinha nome limpo mas todos os bancos negavam crédito. A Credjuris descobriu apontamentos no SCR que eu nem sabia que existiam. Após a regularização, consegui financiar meu carro.',
      rating: 5
    },
    {
      name: 'Fernanda S.',
      location: 'Cuiabá, MT',
      text: 'Minha empresa estava com Rating péssimo no Concentre. Em 4 meses de trabalho, conseguimos aprovar uma linha de crédito de R$ 200 mil para capital de giro.',
      rating: 5
    },
    {
      name: 'Roberto L.',
      location: 'Goiânia, GO',
      text: 'A perícia técnica mostrou exatamente onde estavam os problemas. Processo transparente do início ao fim. Super recomendo para quem está cansado de ter crédito negado.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-emerald-600 text-sm font-semibold tracking-wider uppercase mb-4">
            Resultados Reais
          </span>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            O que nossos clientes dizem
          </h2>
          
          <p className="text-lg text-slate-600 leading-relaxed">
            Histórias reais de pessoas que regularizaram seus dados e voltaram a ter acesso ao crédito.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-slate-100 hover:shadow-lg hover:border-emerald-100 transition-all duration-300"
            >
              {/* Quote Icon */}
              <div className="w-10 h-10 bg-emerald-100 rounded-xl flex items-center justify-center mb-6">
                <Quote className="w-5 h-5 text-emerald-600" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>

              {/* Text */}
              <p className="text-slate-600 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="border-t border-slate-100 pt-4">
                <p className="font-semibold text-slate-800">{testimonial.name}</p>
                <p className="text-sm text-slate-500">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <p className="text-center text-sm text-slate-500 mt-8">
          * Resultados podem variar de acordo com cada caso. Depoimentos editados para preservar a privacidade dos clientes.
        </p>
      </div>
    </section>
  );
};

export default TestimonialsSection;
